import { render, staticRenderFns } from "./warn-24.vue?vue&type=template&id=25272a1b&scoped=true"
import script from "./warn-24.vue?vue&type=script&lang=js"
export * from "./warn-24.vue?vue&type=script&lang=js"
import style0 from "./warn-24.vue?vue&type=style&index=0&id=25272a1b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25272a1b",
  null
  
)

export default component.exports